<template>
  <div class="flex items-center justify-center min-h-screen custom-bg">
    <div class="rounded-2xl p-10 text-center w-1/3 custom-card">
      <div class="flex justify-center mb-4">
        <div
          class="w-16 h-16 flex items-center justify-center rounded-full bg-white border border-green-300 custom-circle"
        >
          <svg
            class="w-10 h-10 text-green-700 custom-icon"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12l2 2l4 -4m6 2a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
            />
          </svg>
        </div>
      </div>

      <h2 class="text-2xl font-semibold text-green-900 mb-2 custom-text">Approved Successfully</h2>
      <p class="text-green-800 text-base custom-text mb-4">
        <i class="el-icon-success"></i>
        Form has been approved successfully.
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ApprovalSuccessPage',
  };
</script>

<style scoped>
  .custom-card {
    background-color: #dfffe2;
    box-shadow: 0 4px 12px rgba(22, 163, 74, 0.15);
    border-left: 6px solid #15803d;
    padding-bottom: 40px;
  }

  .custom-circle {
    border-color: #86efac;
  }

  .custom-icon,
  .custom-text {
    color: #15803d;
  }
</style>
